import './index.css'

const ProductListDetails = ({ productDetails }) => {
  const { title, category, description, image, price, rating } = productDetails

  return (
    <li className="product-card">
      <img
        src={image}
        className="product-image"
        alt={title}
      />

      <div className="product-content">
        <h3 className="product-title">{title}</h3>
        <p className="product-category">by {category}</p>
        <p className="product-description">{description}</p>

        <div className="product-price-rating">
          <p className="product-price">₹{price}</p>
          <div className="product-rating">
            <span>{rating.rate}</span>
            <img
              src="https://assets.ccbp.in/frontend/react-js/star-img.png"
              alt="rating"
              className="star-icon"
            />
          </div>
        </div>

        <p className="product-stock">In stock: {rating.count}</p>
      </div>
    </li>
  )
}

export default ProductListDetails


